import { Box, HStack, Progress, Text } from "@chakra-ui/react";
import BoxHeader from "components/elements/BoxHeader";
import ListTable from "components/elements/ListTable";
import { useLoan } from "providers/loan";
import { useCustomFormats } from "hooks/useCustomFormat";

export function Balance() {
  const { balance } = useLoan();
  const { formatCurrency } = useCustomFormats();

  return (
    <Box flex="2" ml="48px">
      <BoxHeader mb="8px" title="Remaining to Fund" />
      <HStack fontWeight="600" fontSize="20px" mb="10px" whiteSpace="nowrap">
        <Text color="secondary">
          {formatCurrency(balance.loanAmount - balance.remainingBalance)}
        </Text>
        <Text color="#CDCDCD">/ {formatCurrency(balance.loanAmount)}</Text>
      </HStack>
      <Progress variant="green" value={balance.progress} />
      <Text my="4px" color="#90BE95" fontWeight="500" fontSize="14px">
        {balance.progress.toFixed(2)}%
      </Text>
      <ListTable
        rows={[
          {
            label: "Pending drawdowns",
            value: formatCurrency(balance.pendingDraws),
          },
          {
            label: "Funded to Date",
            value: formatCurrency(balance.fundedToDate),
          },
          {
            label: "Remaining Balance",
            value: formatCurrency(balance.remainingBalance),
          },
          {
            label: "Interest",
            value: formatCurrency(balance.interestBalances.totalInterest),
          },
          {
            label: "Default Interest",
            value: formatCurrency(balance.interestBalances.totalDefaultInterest),
          },
          {
            label: "Base Rate",
            value: formatCurrency(balance.interestBalances.totalBaseRate),
          },
          {
            label: "Fees",
            value: formatCurrency(balance.totalFees),
          },
          {
            label: "Total Loan Amount",
            value: formatCurrency(balance.totalLoanCost),
          },
        ]}
      />
    </Box>
  );
}
